// Megamenu 
document.querySelectorAll('.custom_megamenu_wrap').forEach(menuWrap => {
  const buttons = menuWrap.querySelectorAll('.cm_button');
  const images = menuWrap.querySelectorAll('.image-col-data');

  if (buttons.length === 0 || images.length === 0) return;

  buttons[0].classList.add('active');
  const firstVal = buttons[0].getAttribute('data-button');
  images.forEach(img => {
    if (img.getAttribute('data-col') === firstVal) {
      img.classList.add('active');
    }
  });

  buttons.forEach(button => {
    button.addEventListener('mouseenter', () => {
      const buttonVal = button.getAttribute('data-button');

      menuWrap.querySelectorAll('.active').forEach(el => el.classList.remove('active'));
      button.classList.add('active');
      images.forEach(image => {
        if (image.getAttribute('data-col') === buttonVal) {
          image.classList.add('active');
        }
      });
    });

    menuWrap.addEventListener('mouseleave', () => {
      const activeButton = menuWrap.querySelector('.cm_button.active');
      if (!activeButton && buttons[0]) {
        menuWrap.querySelectorAll('.active').forEach(el => el.classList.remove('active'));
        buttons[0].classList.add('active');
        const val = buttons[0].getAttribute('data-button');
        images.forEach(img => {
          if (img.getAttribute('data-col') === val) {
            img.classList.add('active');
          }
        });
      }
    });
  });
}); 



document.addEventListener("click", function (e) {
  const button = e.target.closest(".mobile_cm_button[data-button]");
  if (!button) return;

  const value = button.dataset.button;

  document.querySelectorAll(".dropdown-option-wrap.active").forEach((el) => el.classList.remove("active"));

  const dropdown = document.querySelector(
    `.dropdown-option-wrap[data-col="${value}"]`
  );

  dropdown?.classList.add("active");
});





document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll("header-menu details");

  menuItems.forEach(details => {
    details.addEventListener("mouseenter", () => {
      details.setAttribute("open", true);
    });
    details.addEventListener("mouseleave", () => {
      details.removeAttribute("open");
    });
  });
});




new Swiper('.featured-collection-slider', {
    loop: false,
    slidesPerView: 3,
    spaceBetween: 0, 
    pagination: {
      el: ".featured-collection-section .swiper-pagination",
      clickable: true 
   },
   navigation: {
      nextEl: ".slider-right-arrow",
      prevEl: ".slider-left-arrow",
    },
    breakpoints: {
      0: {
        slidesPerView: 1.3,
        spaceBetween: 15,
        loop: true
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1290: {
        slidesPerView: 4,
        spaceBetween: 22 
      }
    }
});


new Swiper('.bloglist-slider', {
    loop: false,
    slidesPerView: 3,
    spaceBetween: 0, 
    pagination: {
      el: ".featured-blog-section .swiper-pagination",
      clickable: true 
   },
    breakpoints: {
      0: {
        slidesPerView: 1.1,
        spaceBetween: 15,
        loop: true
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 24
      }
    }
});


new Swiper('.testimonial-slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 18,
    centeredSlides: true, 
    pagination: {
      el: ".testimonial-section .swiper-pagination",
      clickable: true
   },
   autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  }
});



// Footer menu toggle
document.querySelectorAll('.footer-menu-colgroup h2.footer-block__heading').forEach(heading => {
  heading.addEventListener('click', () => {
    const parentGroup = heading.closest('.footer-menu-colgroup');
    const allContents = parentGroup.querySelectorAll('.footer-block__details-content');
    const content = heading.nextElementSibling;

    const isActive = content && content.classList.contains('active');
    allContents.forEach(c => c.classList.remove('active'));

    if (content && !isActive) {
      content.classList.add('active');
    }
  });
});




// Collections redmore
document.addEventListener('DOMContentLoaded', function() {
  const collectionDesc = document.querySelector('.collections-dec');
  const readMoreWrap = document.querySelector('.read-morebutton-wrap');
  const readMoreBtn = document.querySelector('.read-morebutton');

  if (collectionDesc && readMoreWrap && readMoreBtn) {
    const metafieldContent = collectionDesc.querySelector('.metafield-rich_text_field');
    
    if (metafieldContent && metafieldContent.scrollHeight > 480) {
      readMoreWrap.classList.remove('hidden');
    }
    readMoreBtn.addEventListener('click', function() {
      collectionDesc.classList.toggle('active');
    });
  }
});

// Collections faq's
const questions = document.querySelectorAll('.collections-faq .collections-question');

questions.forEach((q) => {
  q.addEventListener('click', () => {
    const answer = q.nextElementSibling;
    document.querySelectorAll('.collections-answer').forEach((a) => {
      if (a !== answer) {
        a.classList.remove('active');
      }
    });
    answer.classList.toggle('active');
  });
});



// a href="#" page scroll js 
document.addEventListener('DOMContentLoaded', function() {
  const headerHeight = parseInt(
    getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')
      .replace('px', '')
  ) || 0;

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId && targetId !== '#') {
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }
      }
    });
  });
});



// Product media slider 
const thumbnail_media = document.querySelector('.thumbnail-media-slider');
const main_media_slider = document.querySelector('.product-main-media-slider');

if (thumbnail_media && main_media_slider) {
  const thumbsSwiper = new Swiper(".thumbnail-media-slider", {
    spaceBetween: 24,  
    slidesPerView: 4, 
    slidesPerView: "auto",
    autoHeight: true,
    breakpoints: {
      0: {
        slidesPerView: 4,
        direction: "horizontal",
        spaceBetween: 10
      },
      750: {
        slidesPerView: "auto",
        direction: "vertical",
      }
    }
  });

  const mainSwiper = new Swiper(".product-main-media-slider", {
    spaceBetween: 10,
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: ".slider-right-arrow",
      prevEl: ".slider-left-arrow",
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const mainSliderEl = document.querySelector('.product-main-media-slider');

  if (mainSliderEl && mainSliderEl.swiper) {
    const mainSlider = mainSliderEl.swiper;

    mainSlider.on('slideChange', function() {
      // 1️⃣ Pause normal <video> tags
      const htmlVideos = mainSliderEl.querySelectorAll('video');
      htmlVideos.forEach(video => {
        video.pause();
        video.currentTime = 0;
      });

      // 2️⃣ Pause YouTube iframes
      const youtubeIframes = mainSliderEl.querySelectorAll('iframe[src*="youtube.com"]');
      youtubeIframes.forEach(iframe => {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
      });
    });
  }
});






document.querySelectorAll('.pdp-tab-button').forEach(button => {
  button.addEventListener('click', () => {
    const tabName = button.getAttribute('tab-name');

    document.querySelectorAll('.pdp-tab-button').forEach(btn => btn.classList.remove('active'));
    document.querySelectorAll('.pdp-tab-details').forEach(detail => detail.classList.remove('active'));
    button.classList.add('active');
    const activeTab = document.querySelector(`.pdp-tab-details[tab-details="${tabName}"]`);
    if (activeTab) {
      activeTab.classList.add('active');
    }
  });
});


// newsletter Popup code
document.addEventListener("DOMContentLoaded", function () {
  if (document.cookie.includes("newsletterClosed=true")) return;

  const popup = document.querySelector(".newsletter-popup");
  const PopupWrap = document.querySelector(".newsletter-popup-wrap");
  const overlay = document.querySelector(".custom-popup-overlay");

  if (!PopupWrap || !overlay) return;

  setTimeout(() => {
    popup.classList.add("active");
    overlay.classList.add("active");
    document.body.classList.add("newsletter-popup-open");
  }, 5000);

  // Close popup and set cookie
  function closePopup() {
    popup.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove("newsletter-popup-open");

    // Cookie valid for 1 day
    document.cookie = "newsletterClosed=true; path=/; max-age=" + 60 * 60 * 2400;
  }

  // Attach close events
  document.querySelectorAll(".close_icon, .custom-popup-overlay").forEach(el => {
    el.addEventListener("click", closePopup);
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const forgotLink = document.querySelector('.forgot-password-link');
  const loginBlock = document.querySelector('.login-password-block');
  const recoverBlock = document.querySelector('.recover-password-block');
  const gobackLink = document.querySelector('.goto-login-page');
  const breadcrumbs_title = document.querySelector('.breadcrumbs-title');
  

  if (!forgotLink || !loginBlock || !recoverBlock || !gobackLink || !breadcrumbs_title) return;

  forgotLink.addEventListener('click', (e) => {
    e.preventDefault();
    loginBlock.style.display = 'none';
    recoverBlock.style.display = 'block';
    breadcrumbs_title.textContent = 'Reset Password';
  });

  gobackLink.addEventListener('click', (e) => {
    e.preventDefault();
    loginBlock.style.display = 'block';
    recoverBlock.style.display = 'none';
    breadcrumbs_title.textContent = 'Login';
  });
});


// volume discount button 
document.addEventListener('DOMContentLoaded', function() {
  const volumeButtons = document.querySelectorAll('.volume-button');
  const qtyInput = document.querySelector('.main-pdp-qty-box input.quantity__input');

  if (!volumeButtons.length || !qtyInput) return;

  // 🔹 Function to update active button based on current input value
  function updateActiveVolumeButton() {
    const currentValue = parseInt(qtyInput.value, 10);
    let matched = false;

    volumeButtons.forEach(btn => {
      btn.classList.remove('active');
      if (parseInt(btn.getAttribute('data-qty'), 10) === currentValue) {
        btn.classList.add('active');
        matched = true;
      }
    });

    // If no match, activate the last button
    if (!matched && volumeButtons.length > 0) {
      volumeButtons[volumeButtons.length - 1].classList.add('active');
    }
  }

  // 🔹 On page load
  updateActiveVolumeButton();

  // 🔹 On volume button click
  volumeButtons.forEach(button => {
    button.addEventListener('click', function() {
      const qtyValue = parseInt(this.getAttribute('data-qty'), 10);
      if (!qtyValue) return;

      qtyInput.value = qtyValue;

      // Trigger native change event (for Shopify's JS to detect)
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

      updateActiveVolumeButton();
    });
  });

  // (Optional) 🔹 If you want it to auto-update when user manually changes input
  qtyInput.addEventListener('change', updateActiveVolumeButton);
});



// Login page code
document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.querySelector('#subscription_input');
  const targetInput = document.querySelector('#customer_subscription');
  if (!checkbox || !targetInput) return;
  targetInput.disabled = !checkbox.checked;
  checkbox.addEventListener('change', function () {
    if (this.checked) {
      targetInput.removeAttribute('disabled');
    } else {
      targetInput.setAttribute('disabled', 'disabled');
    }
  });
});



document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById("create_customer");
  const pass1 = document.getElementById("RegisterForm-password");
  const pass2 = document.getElementById("confirm_password");
  const confirm_field = document.querySelector(".confirm-password-field");

  

  if (!pass1 || !pass2 || !form) return;

  function validatePasswords() {
      if (pass1.value === "" || pass2.value === "") {
        confirm_field.classList.add('not_match');
      } else if (pass1.value !== pass2.value) {
        confirm_field.classList.add('not_match');
      } else {
        confirm_field.classList.remove('not_match');
      }
  }

  // Listen for typing in both fields
  pass1.addEventListener("keyup", validatePasswords);
  pass2.addEventListener("keyup", validatePasswords);

  // Optional: prevent default submit if you keep the form
  form.addEventListener("submit", function (e) {
      e.preventDefault();
      validatePasswords();
  });
});




document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.faq-question').forEach(title => {
    title.addEventListener('click', () => {

      const item = title.closest('.faq-block');
      const parentTab = item.closest('.faq-tab-info');

      parentTab.querySelectorAll('.faq-block').forEach(other => {
        if (other !== item) {
          other.classList.remove('active');
        }
      });
      item.classList.toggle('active');
    });
  });
  const buttons = document.querySelectorAll(".policy-hero-section .tab-button");
  const contents = document.querySelectorAll(".policy-hero-section .faq-tab-info");

  buttons.forEach(button => {
    button.addEventListener("click", function () {
      const selectedFaq = this.getAttribute("data_faq");

      buttons.forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");
      contents.forEach(content => content.classList.remove("active"));
      const activeContent = document.querySelector(
        `.policy-hero-section .faq-tab-info[data_faq="${selectedFaq}"]`
      );

      if (activeContent) {
        activeContent.classList.add("active");

        const firstFAQ = activeContent.querySelector(".faq-block");
        if (firstFAQ) {
          activeContent.querySelectorAll(".faq-block").forEach(f => f.classList.remove("active"));
          firstFAQ.classList.add("active");
        }
      }
    });
  });

});